// extracted by mini-css-extract-plugin
export default {"wrapper":"Share_wrapper__1gI4R","title":"Share_title__kmxTQ","buttons":"Share_buttons__87z7y","copy":"Share_copy__jRsUL"};